import { render, staticRenderFns } from "./web.vue?vue&type=template&id=26f67416"
import script from "./web.vue?vue&type=script&lang=js"
export * from "./web.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports